export { Autotrader } from './lib/autotrader'
export { getStaticProps } from './lib/get-static-props'
